export const ROUTE_LOGIN = '/login';
export const ROUTE_REGISTRATION = '/anmeldung';
// export const ROUTE_DASHBOARD = '/dashboard';
export const ROUTE_DASHBOARD = '/kunden';

export const ROUTE_CARDS = '/karten';
export const ROUTE_CHAT = '/nachrichten';
export const ROUTE_CLIENTS = '/kunden';
export const ROUTE_CLIENTS_NEW = '/kunden/neu';
export const ROUTE_MY_CLIENTS = '/meine-kunden';
export const ROUTE_PROFILE = '/profil';
export const ROUTE_USERS = '/benutzer';
export const ROUTE_USER_RECOMMENDATIONS = '/empfehlungen';
export const ROUTE_CONTROL = '/kontrolle';
export const ROUTE_TODO = '/aufgaben';
export const ROUTE_PERMISSIONS = '/berechtigungen';

export const ROUTE_ERROR_404 = '/fehler/404';
export const ROUTE_ERROR_406 = '/fehler/406';
export const ROUTE_ERROR_500 = '/fehler/500';
export const ROUTE_ERROR_503 = '/fehler/503';
